import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, class_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { loadEffect, LoadState$2, LoadState_map, getTranslationFrom, GlobalDependencies$reflection } from "../../Global.js";
import { PaymentMethod$reflection } from "../../DomainTypes.js";
import { Locale$reflection } from "../../Utils.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector, useDispatch } from "../../Redux/Store.js";
import { sortByDescending, head, empty, filter, isEmpty, map } from "../../fable_modules/fable-library.3.7.20/List.js";
import { isActiveFee, Fee_FromDTO } from "../FeesTable/Model.js";
import * as react from "react";
import { createFeeV2, saveAnnulFee, Thunks_loadInvoiceeFeesThunk } from "../../Api/Fee.js";
import { reactivateFee as reactivateFee_1, terminateFee as terminateFee_1, updateFee as updateFee_1, loadChartOfAccounts as loadChartOfAccounts_1 } from "./Api.js";
import { info, error } from "../../Components/Message/Message.js";
import { dotsLoading } from "../../ViewUtils.js";
import { singleton, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { CreateFeeProps, renderCreateFeeButton, FeesTableProps, view } from "../FeesTable/View.js";
import { monthsInAdvance } from "../../CommonData.js";
import { parse } from "../../fable_modules/fable-library.3.7.20/Int32.js";
import { convertFeeToTerminateFeeDTO, getUpdateFeeDTOs } from "./Model.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_1 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { saveMaxBilledToNextTime as saveMaxBilledToNextTime_1, saveEarliestInvoiceDate as saveEarliestInvoiceDate_1, saveBilledTo as saveBilledTo_1 } from "../FeesTable/Api.js";
import { FeeVersion, FeeType } from "../FeeModal/View.js";
import { CollapseProps, collapse } from "../../Components/Collapse/Collapse.js";
import { InactiveFeesTableProps, renderInactiveFeesTable } from "../FeesTable/InactiveFees.js";
import { compareArrays, compare, max } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { MessageType, renderAsModal } from "../../Components/Modals/InfoMessage/InfoMessage.js";
import { getCreateFeeDTOV2 } from "../FeeModal/Model.js";
import { FeeConfig } from "../../GlobalTypes.js";
import { Helpers_equalsButFunctions } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Helpers.fs.js";
import "../../../src/Containers/CustomerFees/View.scss";


export class CustomerFeesProps extends Record {
    constructor(InvoiceeNr, GlobalDependencies, PaymentMethod, Locale) {
        super();
        this.InvoiceeNr = InvoiceeNr;
        this.GlobalDependencies = GlobalDependencies;
        this.PaymentMethod = PaymentMethod;
        this.Locale = Locale;
    }
}

export function CustomerFeesProps$reflection() {
    return record_type("Containers.CustomerFees.View.CustomerFeesProps", [], CustomerFeesProps, () => [["InvoiceeNr", class_type("System.Int64")], ["GlobalDependencies", GlobalDependencies$reflection()], ["PaymentMethod", PaymentMethod$reflection()], ["Locale", Locale$reflection()]]);
}

export const renderCustomerFees = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_9, _arg_10, inputRecord;
    const reduxDispatch = useDispatch();
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const invoiceeFeesLoadState = LoadState_map((invoiceeFees) => map((arg_1) => Fee_FromDTO(props.GlobalDependencies.ClientNr, arg_1), invoiceeFees), useSelector((state_1) => state_1.Invoicee.InvoiceeFees));
    const chartOfAccountsLoadState = react.useState(new LoadState$2(0));
    const errorMessageState = react.useState(void 0);
    const loadInvoiceeFees = () => {
        reduxDispatch(Thunks_loadInvoiceeFeesThunk(props.GlobalDependencies.ClientNr, props.InvoiceeNr));
    };
    const loadChartOfAccounts = () => {
        loadEffect(() => loadChartOfAccounts_1(props.GlobalDependencies.ClientNr), (arg_2) => {
            chartOfAccountsLoadState[1](arg_2);
        });
    };
    react.useEffect(() => {
        loadInvoiceeFees();
        loadChartOfAccounts();
    }, []);
    react.useEffect(loadInvoiceeFees, [props.InvoiceeNr, props.GlobalDependencies]);
    react.useEffect(loadChartOfAccounts, [props.GlobalDependencies]);
    let feesTableHtml;
    if (invoiceeFeesLoadState.tag === 3) {
        const children_1 = [error(invoiceeFeesLoadState.fields[0].split(""))];
        feesTableHtml = react.createElement("div", {}, ...children_1);
    }
    else if (invoiceeFeesLoadState.tag === 1) {
        feesTableHtml = dotsLoading;
    }
    else if (invoiceeFeesLoadState.tag === 2) {
        if (isEmpty(invoiceeFeesLoadState.fields[0])) {
            const children_3 = [info(getTranslation("CustomerContract.Invoicee.CustomerFees.FeesMissing").split(""))];
            feesTableHtml = react.createElement("span", {
                ["data-translation"]: "CustomerContract.Invoicee.CustomerFees.FeesMissing",
            }, ...children_3);
        }
        else {
            const children_6 = toList(delay(() => {
                let _arg_8;
                const matchValue = chartOfAccountsLoadState[0];
                return (matchValue.tag === 2) ? singleton(view(new FeesTableProps(filter(isActiveFee, invoiceeFeesLoadState.fields[0]), empty(), props.GlobalDependencies, void 0, void 0, matchValue.fields[0], props.PaymentMethod, (_arg_8 = monthsInAdvance(getTranslation), isEmpty(_arg_8) ? 0 : parse(head(_arg_8)[0], 511, false, 32)), void 0, (tupledArg) => {
                    const feeJsonModel = getUpdateFeeDTOs(tupledArg[0], tupledArg[1]);
                    startImmediate(singleton_1.Delay(() => singleton_1.Bind(updateFee_1(props.GlobalDependencies.ClientNr, props.InvoiceeNr, feeJsonModel), (_arg_1) => {
                        const result_1 = _arg_1;
                        if (result_1.tag === 0) {
                            loadInvoiceeFees();
                            return singleton_1.Zero();
                        }
                        else {
                            errorMessageState[1](result_1.fields[0]);
                            return singleton_1.Zero();
                        }
                    })));
                }, (tupledArg_1) => {
                    const terminateFeeJson = convertFeeToTerminateFeeDTO(tupledArg_1[1]);
                    startImmediate(singleton_1.Delay(() => singleton_1.Bind(terminateFee_1(props.GlobalDependencies.ClientNr, props.InvoiceeNr, tupledArg_1[0].FeeNumber, terminateFeeJson), (_arg_2) => {
                        const result_2 = _arg_2;
                        if (result_2.tag === 0) {
                            loadInvoiceeFees();
                            return singleton_1.Zero();
                        }
                        else {
                            errorMessageState[1](result_2.fields[0]);
                            return singleton_1.Zero();
                        }
                    })));
                }, (fee_2) => {
                    startImmediate(singleton_1.Delay(() => singleton_1.Bind(saveAnnulFee(props.GlobalDependencies.ClientNr, fee_2.FeeNumber), (_arg_3) => {
                        const result_3 = _arg_3;
                        if (result_3.tag === 0) {
                            loadInvoiceeFees();
                            return singleton_1.Zero();
                        }
                        else {
                            errorMessageState[1](result_3.fields[0]);
                            return singleton_1.Zero();
                        }
                    })));
                }, (feeNr_1, newBilledToDate) => {
                    startImmediate(singleton_1.Delay(() => singleton_1.Bind(saveBilledTo_1(props.GlobalDependencies.ClientNr, feeNr_1, newBilledToDate), (_arg_5) => {
                        const result_5 = _arg_5;
                        if (result_5.tag === 0) {
                            loadInvoiceeFees();
                            return singleton_1.Zero();
                        }
                        else {
                            errorMessageState[1](result_5.fields[0]);
                            return singleton_1.Zero();
                        }
                    })));
                }, (feeNr_2, date) => {
                    startImmediate(singleton_1.Delay(() => singleton_1.Bind(saveEarliestInvoiceDate_1(props.GlobalDependencies.ClientNr, feeNr_2, date), (_arg_6) => {
                        const result_6 = _arg_6;
                        if (result_6.tag === 0) {
                            loadInvoiceeFees();
                            return singleton_1.Zero();
                        }
                        else {
                            errorMessageState[1](result_6.fields[0]);
                            return singleton_1.Zero();
                        }
                    })));
                }, (feeNr_3, date_1) => {
                    startImmediate(singleton_1.Delay(() => singleton_1.Bind(saveMaxBilledToNextTime_1(props.GlobalDependencies.ClientNr, feeNr_3, date_1), (_arg_7) => {
                        const result_7 = _arg_7;
                        if (result_7.tag === 0) {
                            loadInvoiceeFees();
                            return singleton_1.Zero();
                        }
                        else {
                            errorMessageState[1](result_7.fields[0]);
                            return singleton_1.Zero();
                        }
                    })));
                }, new FeeType(3)))) : singleton(react.createElement(react.Fragment, {}));
            }));
            feesTableHtml = react.createElement("div", {
                className: "fit-content mb-4",
                ["data-regression"]: "customer-fees-table",
            }, ...children_6);
        }
    }
    else {
        feesTableHtml = react.createElement(react.Fragment, {});
    }
    let inactiveFeesTableHtml;
    switch (invoiceeFeesLoadState.tag) {
        case 3:
        case 1: {
            inactiveFeesTableHtml = react.createElement(react.Fragment, {});
            break;
        }
        case 2: {
            const children_11 = [collapse(new CollapseProps(renderInactiveFeesTable(new InactiveFeesTableProps(sortByDescending((x) => [max(compare, x.EndDate, x.StartDate), x.CreatedTime], filter((arg_11) => (!isActiveFee(arg_11)), invoiceeFeesLoadState.fields[0]), {
                Compare: compareArrays,
            }), empty(), props.Locale, (feeNr) => {
                startImmediate(singleton_1.Delay(() => singleton_1.Bind(reactivateFee_1(props.GlobalDependencies.ClientNr, feeNr), (_arg_4) => {
                    const result_4 = _arg_4;
                    if (result_4.tag === 0) {
                        loadInvoiceeFees();
                        return singleton_1.Zero();
                    }
                    else {
                        errorMessageState[1](result_4.fields[0]);
                        return singleton_1.Zero();
                    }
                })));
            }, props.GlobalDependencies.ClientConfig.FeeConfig.UsesUnitPrice, props.GlobalDependencies.ClientNr)), (children_9 = [getTranslation("CustomerContract.Invoicee.Subscriptions.TerminatedFees")], react.createElement("h5", {
                ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.TerminatedFees",
            }, ...children_9)), false))];
            inactiveFeesTableHtml = react.createElement("div", {
                ["data-regression"]: "customer-fees-inactive-table",
            }, ...children_11);
            break;
        }
        default: {
            inactiveFeesTableHtml = react.createElement(react.Fragment, {});
        }
    }
    let errorModalHtml;
    const matchValue_1 = errorMessageState[0];
    if (matchValue_1 != null) {
        const errorMsg = matchValue_1;
        errorModalHtml = renderAsModal("Error", react.createElement("div", {}, errorMsg), new MessageType(2), getTranslation("Common.Close"), (_arg_9) => {
            errorMessageState[1](void 0);
        });
    }
    else {
        errorModalHtml = react.createElement(react.Fragment, {});
    }
    let createFeeButtonHtml;
    const matchValue_2 = chartOfAccountsLoadState[0];
    createFeeButtonHtml = ((matchValue_2.tag === 2) ? renderCreateFeeButton(new CreateFeeProps(empty(), matchValue_2.fields[0], props.GlobalDependencies.ClientConfig.UseAccountNo, (_arg_10 = monthsInAdvance(getTranslation), isEmpty(_arg_10) ? 0 : parse(head(_arg_10)[0], 511, false, 32)), void 0, void 0, props.Locale, props.GlobalDependencies.CountryCode, props.PaymentMethod, void 0, (vm) => {
        const feeDTO = getCreateFeeDTOV2(props.InvoiceeNr, void 0, vm);
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(createFeeV2(props.GlobalDependencies.ClientNr, feeDTO), (_arg) => {
            const result = _arg;
            if (result.tag === 0) {
                loadInvoiceeFees();
                return singleton_1.Zero();
            }
            else {
                errorMessageState[1](result.fields[0]);
                return singleton_1.Zero();
            }
        })));
    }, props.GlobalDependencies.ClientConfig.EnableFeesV2 ? (new FeeVersion(1, props.GlobalDependencies.ClientConfig.FeeConfig)) : (new FeeVersion(0, (inputRecord = props.GlobalDependencies.ClientConfig.FeeConfig, new FeeConfig(true, true, inputRecord.MonthlyDate, false, false, false, false, false, false, true, inputRecord.DefaultMonthsInAdvance, inputRecord.DefaultCancellationPeriodMonths, inputRecord.UsesUnitPrice)))), new FeeType(1), props.GlobalDependencies.ClientConfig.FeeConfig.UsesUnitPrice)) : react.createElement(react.Fragment, {}));
    return react.createElement("div", {
        className: "customer-fees",
        ["data-regression"]: "customer-fees-container",
    }, createFeeButtonHtml, feesTableHtml, inactiveFeesTableHtml, errorModalHtml);
}, "CustomerFees", Helpers_equalsButFunctions, void 0, "renderCustomerFees", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\CustomerFees\\View.fs", 270);

